import axios from 'axios'
import { userManager } from 'core/configs/userManager'
import {getBookmapAuthHeaders, isBridgeAvailable} from "../configs/bookmapBridge";

const httpClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
})

// export const userManager = new UserManager(OAUTH_CONFIG)

httpClient.interceptors.request.use(async (config) => {
  try {
    if (isBridgeAvailable()) {
      Object.assign(config.headers, await getBookmapAuthHeaders())
    } else {
      const token = (await userManager.getUser())?.access_token
      if (token) config.headers.Authorization = `Bearer ${token}`
    }
    return config
  } catch (error) {
    console.error('Error getting token', error)
    return config
  }
})

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (window.location.pathname !== '/login' && window.location.pathname !== '/callback') {
        window.location.href = window.location.origin + '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default httpClient
